export default __webpack_public_path__ + "d9f384c61ee6233f6840a4bd3493e603.png";